import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig, EndpointParserFn } from '../../models/base-api-config.model';

export type CreatorDiscoveryApiConfig = BaseApiConfig<{
  getCreatorsByHashtags: string;
  getPostsByHashtag: EndpointParserFn;
  createAssistanceRequest: string;
  getAssistanceRequests: string;
  cancelAssistanceRequest: EndpointParserFn;
  submitAssistanceRequestFeedback: EndpointParserFn;
  getAssistanceRequestCreators: EndpointParserFn;
  getCreatorByHandle: string;
  getCreatorHandleSearchStatus: string;
  getCreatorHandleSearch: EndpointParserFn;
  requestLinkedAccounts: EndpointParserFn;
  getLinkedAccounts: EndpointParserFn;
  refreshCreatorSignals: string;
}>;

export const CREATOR_DISCOVERY_API_CONFIG = new InjectionToken<CreatorDiscoveryApiConfig>(
  'CREATOR_DISCOVERY_API_CONFIG'
);

export const provideCreatorDiscoveryApiConfig = (config: CreatorDiscoveryApiConfig): StaticProvider => ({
  provide: CREATOR_DISCOVERY_API_CONFIG,
  useValue: config,
});
